import { List, ListItem } from "@mui/material";
import { Height } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import heightRestrictionIconSource from "../../assets/heightRestrictionIcon.svg"

export default function HeightRestrictions(props: IRoutePartProps) {

    return (  
        <>
            {props.roadFeatures && props.roadFeatures.heights && props.roadFeatures.heights.length > 0 &&
            <List>
                {props.roadFeatures.heights.map( (heightRestriction: Height, index: number) => (
                    <ListItem 
                        key={heightRestriction.heightRestriction + index} 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(heightRestriction, event)}}
                        onMouseEnter={() => {props.onMouseEnterItem(heightRestriction)}}
                        onMouseLeave={props.onMouseLeaveItem}>
                            <img src={heightRestrictionIconSource} height="24" style={{paddingRight:"5px"}} alt="Height Restriction icon" title="heightRestrictionIcon"/> Maks høyde: {heightRestriction.heightRestriction}m
                    </ListItem>
                ))}
            </List>        
            }
        </>      
    )
}